<template>
    <div>
        <div class="d-flex justify-content-center" v-if="listLoading">
            <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
        </div>
        <div class="listComps" v-if="!listLoading">
            <TableActionHeader @filterChange="(val) => { this.filterString = val }" :selectOptions="statusOptions"
                :selected="statusFilter" @filterSelect="onFilterSelect" @newItem="this.onNewDoc">
            </TableActionHeader>
            <b-table hover striped :items="listDataFromStore" :fields="fields" :responsive="false" :small="true"
                primary-key="id" ref="documentOptionList" selectable select-mode="single" @row-selected="onRowSelected"
                :filter="filter" :filter-function="listFilterFunction" :per-page="pagingPerPage"
                @filtered="this.onFiltered" :current-page="this.currentPage" class="infotext-table">
                <template v-slot:cell(status)="data">
                    <InfoValidityIcon :info="data.item" scale="1.5" />
                </template>
                <template v-slot:cell(document_name)="data">
                    <span>{{ data.item.documentMetadata.name }}</span>
                </template>
                <template v-slot:cell(validity_time)="data">
                    <p class="timeInTableCell"> &#8614; {{ validityBegins(data.item) }}</p>
                    <p class="timeInTableCell"> &#8677; {{ validityEnds(data.item) }}</p>
                </template>
            </b-table>
            <TablePagination :perPage="pagingPerPage" :totalRows="listLength" @pageChange="onPageChange" />
        </div>
    </div>
</template>

<script>
import documents from '@/store/documents/documents';
import TableActionHeader from '@/components/Misc/TableActionHeader.vue';
import TablePagination from '@/components/Misc/TablePagination.vue';
import moment from 'moment';

export default {
    name: 'DocumentOptionList',
    components: {
        TableActionHeader,
        TablePagination
    },
    data() {
        return {
            selected: [],
            filterString: null,
            listLoading: false,
            currentPage: 1,
            pagingPerPage: 10,
            listLength: 0,
            fields: [
                { key: 'status', label: this.$t('document_list.validity'), sortable: true, tdClass: 'status' },
                { key: 'document_name', label: this.$t('document_list.subject'), sortable: true },
                { key: 'validity_time', label: this.$t('document_list.validity_time'), sortable: true },
            ],
            statusOptions: [
                { id: 'all', label: this.$t('document_list.status.all'), icon: 'list' },
                { id: 'valid', label: this.$t('document_list.status.valid'), icon: 'check-circle', variant: 'success' },
                { id: 'upcoming', label: this.$t('document_list.status.upcoming'), icon: 'check-circle', variant: 'warning' },
                { id: 'expired', label: this.$t('document_list.status.expired'), icon: 'x-circle', variant: 'secondary' }
            ],
            statusFilter: 'valid'
        };
    },
    computed: {
        filter() {
            return this.statusFilter + this.filterString;
        },
        listDataFromStore() {
            return this.$store.state.documents.documentOptionList.listData;
        },
        listLengthFromStore() {
            return this.listDataFromStore.length;
        }
    },
    beforeCreate() {
        if (!this.$store.state.documents) {
            this.$store.registerModule('documents', documents);
        }
    },
    mounted() {
        if (this.listDataFromStore.length === 0) {
            this.fetchOptions();
        }
        this.deselectAll();
    },
    watch: {
        listDataFromStore() {
            this.listLength = this.listLengthFromStore;
            this.listLoading = false;
        }
    },
    methods: {
        fetchOptions() {
            this.listLoading = true;
            this.$store.dispatch('documents/getDocumentOptions')
                .catch(error => {
                    console.error('Failed to fetch documentOptions:', error);
                    this.listLoading = false;
                    this.$travellerGetDataError();
                });
        },
        listFilterFunction(item) {
            const statusFilterOK = this.statusFilter === 'all' || this.getValidity(item) === this.statusFilter;

            if (!this.filterString || this.filterString === '') {
                return statusFilterOK;
            }

            if (statusFilterOK && this.filterString.length >= 2) {
                try {
                    const matchString = `.*${this.filterString}.*`;
                    const regex = new RegExp(matchString, 'i');
                    return regex.test(item.documentMetadata.name);
                } catch (err) {
                    return true;
                }
            }
            return false;
        },
        onFiltered(filteredList) {
            this.listLength = filteredList.length;
        },
        onNewDoc() {
            this.$emit('newItem');
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        getSelectedItem() {
            return this.selected;
        },
        dateFormatter(dateString) {
            const datetime = moment(dateString);
            return datetime.format('D.M.YYYY HH:mm');
        },
        onRowSelected(items) {
            this.selected = items;
            this.$emit('selectedItem', this.selected);
        },
        deselectAll() {
            this.$refs.documentOptionList.clearSelected();
        },
        validityBegins(item) {
            if (item.validity_begins) {
                const datetime = moment(item.validity_begins);
                if (datetime.isValid()) {
                    return datetime.format('D.M.YYYY');
                }
            }
            return '';
        },
        validityEnds(item) {
            if (item.validity_ends) {
                const datetime = moment(item.validity_ends);
                if (datetime.isValid()) {
                    return datetime.format('D.M.YYYY');
                }
            }
            return '';
        },
        onFilterSelect(id) {
            this.statusFilter = id;
        },
        getValidity(item) {
            let validity = '?';
            if (item && item.validity_begins && item.validity_ends) {
                const now = Date.now();
                const from = Date.parse(item.validity_begins);
                const to = Date.parse(item.validity_ends);
                if (from <= now && to >= now) validity = 'valid';
                else if (from > now) validity = 'upcoming';
                else if (to < now) validity = 'expired';
            }
            return validity;
        }
    }
};
</script>

<style scoped lang="scss">
.timeInTableCell {
    margin-bottom: 0.1rem;
}
</style>
